export default {
  // 查询养护计划详情
  selectYhDailyPlanByPlanId: '/business/yhDailyPlan/selectYhDailyPlanByPlanId',
  // 分页查询养护计划列表
  selectYhDailyPlanByPage: '/business/yhDailyPlan/selectYhDailyPlanByPage',
  // 查询新养护计划列表
  selectYhDailyPlanByList: '/business/yhDailyPlan/selectYhDailyPlanByList',
  // 查询计划任务关联的现场作业列表
  selectYhDailyWorkByList: '/business/yhDailyPlan/selectYhDailyWorkByList',
  // 按月汇总工单状态
  selectMonthOrderStatusSum: '/business/workOrderStats/selectMonthOrderStatusSum',
  // 查询工单列表(带附件)
  selectWorkOrderList: '/business/workOrder/selectWorkOrderList',
  // 项目日报汇总统计
  selectProjectDailySum: '/business/yhProjectDaily/selectProjectDailySum',
  // 项目日报大平台
  selectProjectDailySumV2:'/business/yhProjectDaily/selectProjectDailySumV2',
  // 日报详情（基本信息、养护作业、其他事项）
  selectYhProjectDailyByDailyId: '/business/yhProjectDaily/selectYhProjectDailyByDailyId',
  // 任务工单
  selectDailyOrder: '/business/yhProjectDaily/selectDailyOrder',
  // 劳务考勤
  selectLabourServiceStatisticByDaily: '/business/yhAttendanceStatistics/selectLabourServiceStatisticByDaily',
  // 机械台班
  selectYhMachineTeamLineByList: '/business/yhMachineTeam/selectYhMachineTeamLineByList',
  // 物料信息
  selectYhDetailedDaily: '/business/yhDetailed/selectYhDetailedDaily',
  // 客户评价
  selectYhAppraiseByList: '/business/yhAppraise/selectYhAppraiseByList',
  // 大平台养护工单统计
  selectLcWorkOrderByCountV2:'/business/lcWorkOrder/selectLcWorkOrderByCountV2'
}
